import React, { MouseEvent } from 'react';
import styled from 'styles/styled-components';
import { InfoIcon, XIcon } from './icons';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Box = styled.div`
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  width: 343px;
  max-width: calc(100vw - 32px);
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  box-sizing: border-box;
`;

const CloseButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Title = styled.p`
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #111827;
  text-align: center;
`;

const Body = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #303643;
  text-align: center;
`;

const OpenAppButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  background: #43a047;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  &:hover {
    opacity: 0.9;
  }
`;

interface MobileAppOnlyModalProps {
  title: string;
  body: string;
  openAppLabel: string;
  onClose: () => void;
  onOpenApp: () => void;
}

const MobileAppOnlyModal = ({ title, body, openAppLabel, onClose, onOpenApp }: MobileAppOnlyModalProps) => (
  <Overlay onClick={onClose}>
    <Box onClick={(e: MouseEvent) => e.stopPropagation()}>
      <CloseButton onClick={onClose} aria-label="close">
        <XIcon />
      </CloseButton>

      <Content>
        <div>
          <IconWrapper>
            <InfoIcon />
          </IconWrapper>

          <Title>{title}</Title>

          <Body>{body}</Body>
        </div>

        <OpenAppButton onClick={onOpenApp}>{openAppLabel}</OpenAppButton>
      </Content>
    </Box>
  </Overlay>
);

export default MobileAppOnlyModal;
